/**
 * Canonical list of POS checkout keyboard shortcuts (F1–F12).
 *
 * Single source of truth shared by:
 *  - the keyboard handler on the checkout screen
 *    (features/pos/checkout/checkout.component.ts)
 *  - the help "Keyboard Shortcuts" workspace panel in the header
 *    (shared/layout/main-layout/main-layout.component.*)
 *
 * Keep this in `shared/` so the layout can reference it without depending
 * on the lazy-loaded POS feature module.
 */
export interface PosShortcut {
  /** Function key label, e.g. 'F1'. */
  key: string;
  /** Short action name shown as the row title. */
  action: string;
  /** One-line helper text describing what the key does. */
  description: string;
  /** Material icon name for the action. */
  icon: string;
}

export const POS_SHORTCUTS: PosShortcut[] = [
  {
    key: 'F1',
    action: 'Product Search',
    description: 'Jump to the product search box',
    icon: 'search',
  },
  {
    key: 'F2',
    action: 'Customer Search',
    description: 'Find and attach an existing customer',
    icon: 'person_search',
  },
  {
    key: 'F3',
    action: 'New Customer',
    description: 'Create a new customer for this sale',
    icon: 'person_add',
  },
  {
    key: 'F4',
    action: 'Hold Sale',
    description: 'Park the current cart to recall later',
    icon: 'pause_circle',
  },
  {
    key: 'F5',
    action: 'Recall Sale',
    description: 'Bring back a previously held sale',
    icon: 'replay',
  },
  {
    key: 'F6',
    action: 'Quantity',
    description: 'Edit the quantity of the selected item',
    icon: 'tag',
  },
  {
    key: 'F7',
    action: 'Discount',
    description: 'Apply a discount to the order',
    icon: 'local_offer',
  },
  {
    key: 'F8',
    action: 'Remove Item',
    description: 'Remove the selected item from the cart',
    icon: 'delete',
  },
  {
    key: 'F9',
    action: 'Notes',
    description: 'Add a note to the order',
    icon: 'note_add',
  },
  {
    key: 'F10',
    action: 'Payment',
    description: 'Open the payment dialog',
    icon: 'payments',
  },
  {
    key: 'F11',
    action: 'Print',
    description: 'Print a quote for the current cart',
    icon: 'print',
  },
  {
    key: 'F12',
    action: 'Complete Sale',
    description: 'Finalize and complete the transaction',
    icon: 'check_circle',
  },
];
